import { render, staticRenderFns } from "./HLIncentiveNotGiftedTile.vue?vue&type=template&id=37ff6c11"
import script from "./HLIncentiveNotGiftedTile.vue?vue&type=script&lang=js"
export * from "./HLIncentiveNotGiftedTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports